import { AxiosPromise, AxiosStatic } from "axios";
import { FileInterface, KycDocumentType, KycProfile } from "../types";

export const uploadKYCDocument =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    file: File,
    documentType: KycDocumentType
  ): AxiosPromise<FileInterface> => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("documentType", documentType);

    return await appAxios.post(`${serverURL}/kyc/document`, formData, {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

/**
 * @deprecated Use deleteKycDocument instead. This helper targets the legacy
 * Yoti endpoint and will be removed once the migration is complete.
 */
export const deleteKYCDocument =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (documentId: string): AxiosPromise<void> =>
    await appAxios.delete(`${serverURL}/yoti/document/${documentId}`, {
      withCredentials: true,
    });

export const deleteKycDocument =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (documentId: string): AxiosPromise<void> =>
    await appAxios.delete(`${serverURL}/kyc/document/${documentId}`, {
      withCredentials: true,
    });

export const putKycDescriptions =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (data: {
    sourceOfFundDescription?: string;
    proofOfAddressDescription?: string;
  }): AxiosPromise<KycProfile> => {
    return await appAxios.put(`${serverURL}/kyc`, data, {
      withCredentials: true,
    });
  };

/**
 * @deprecated Use putKycDescriptions instead. This function will be removed in a future version.
 * Legacy function maintained for backward compatibility.
 */
export const postSourceOfFundDescription =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (sourceOfFundDescription: string): AxiosPromise<KycProfile> => {
    return await appAxios.post(
      `${serverURL}/yoti/sourceOfFund`,
      {
        sourceOfFundDescription,
      },
      {
        withCredentials: true,
      }
    );
  };

export const markKycSubmitted =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<KycProfile> => {
    return await appAxios.post(
      `${serverURL}/kyc/mark-submitted`,
      {},
      {
        withCredentials: true,
      }
    );
  };
